<template>
  <div>
    <el-form ref="generatorForm" :model="report" :rules="rules" label-width="120px">
      <el-form-item label="Report Type" prop="type">
        <el-select class="full-width" v-model="report.type">
          <el-option
            v-for="item in reportTypes"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>

      <el-form-item v-if="report.type === 'CAMPAIGN'" label="Campaign" prop="id">
        <el-select class="full-width" :clearable="true" :filterable="true" v-model="report.id">
          <el-option
            v-for="campaign in campaigns"
            :key="campaign.id"
            :label="campaign.title"
            :value="campaign.id"
          />
        </el-select>
      </el-form-item>

      <el-form-item v-if="report.type === 'SURVEY'" label="Survey" prop="id">
        <el-select class="full-width" v-model="report.id">
          <el-option
            v-for="survey in surveys"
            :key="survey.id"
            :label="survey.title"
            :value="survey.id"
          />
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer clearfix">
      <span class="pull-right">
        <el-button id="cancel" type="danger" @click="cancel" plain>Cancel</el-button>
        <el-button id="save" type="primary" :loading="loading" @click="generate" plain>
          <span v-if="!loading">Generate</span>
          <span v-else>Generating</span>
          </el-button
        >
      </span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'GenerateReport',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    campaigns: {
      type: Array,
      default: () => ([]),
    },
    surveys: {
      type: Array,
      default: () => ([]),
    },
  },
  data: () => ({
    reportTypes: [
      { value: 'PROGRAMMING', label: 'Programming Dashboard' },
      { value: 'CAMPAIGN', label: 'Campaign Summary' },
      { value: 'SURVEY', label: 'Survey Summary' },
    ],
    report: {
      type: null,
      id: null,
    },
    rules: {
      type: [{ required: true, message: 'Please select a report type', trigger: 'blur' }],
      id: [{ required: true, message: 'Please make a selection', trigger: 'blur' }],
    },
  }),
  methods: {
    generate() {
      this.$refs.generatorForm.validate(valid => {
        if (valid) return this.$emit('generate', this.report);
        return false;
      });
    },
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// GenerateReport.vue?2a541ae4